import {createContainer} from 'unstated-next';
import {useAuthenticationHook} from './hook';

const AuthenticationContainer = createContainer(useAuthenticationHook);

export const AuthenticationProvider = AuthenticationContainer.Provider;
export const useAuthentication = AuthenticationContainer.useContainer;
